import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit, Renderer2 } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OnlinePaymentEnum } from 'src/app/models/Payment/OnlinePaymentType.enum';
import { HPayementService } from 'src/app/services/h-payement.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-payment-card-form',
  templateUrl: './payment-card-form.component.html',
  styles: [
  ]
})
export class PaymentCardFormComponent implements OnInit {
  @Input() paymentObj: any;
  dataLoading = false;
  paymentIframeLoader = false;
  paymentProvider = OnlinePaymentEnum.Visa_MasterCard;
  referencePaymentUrl:any = null;
  onlinePaymentEnum = OnlinePaymentEnum;
  paymentMethods = [
    { name: 'payment.visaMastercard', value: OnlinePaymentEnum.Visa_MasterCard, imgPath: 'assets/images/icons/payment-icon-card.svg' },
    { name: 'payment.mada', value: OnlinePaymentEnum.Mada, imgPath: 'assets/images/icons/mada_logo.png' },
    { name: 'payment.applePay', value: OnlinePaymentEnum.ApplePay, imgPath: 'assets/images/icons/apple-pay-logo-svgrepo-com.svg' },
    { name: 'payment.stcPay', value: OnlinePaymentEnum.STCPay, imgPath: 'assets/images/icons/stcPay.svg' },
  ];

  constructor(
    private service: HPayementService,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    public translate: TranslateService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.getCopyAndPayId();
  }

  getCopyAndPayId() {
    this.dataLoading = true;

    this.paymentObj.paymentType = this.paymentProvider;
    this.service.getCopyAndPayId(this.paymentObj , this.paymentObj.isRenew).subscribe(
      (res) => {
        this.referencePaymentUrl = `./assets/paymentWidget.html?brand=${this.paymentProvider}&scriptUrl=${res.webUrl}&color=469595`;
        this.dataLoading = false;
      },
      (err) => {
        this.dataLoading = false;
        this.openSnackBar(err.message);
      }
    );

  }

  changeMethod(id) {
    const oldScript = document.getElementById('e-payment-script');
    if (oldScript) {
      this.renderer.removeChild(this.document.body, oldScript);
    }
    const oldForm = document.getElementById('eFinanceForm');

    if (oldForm) {
      oldForm.remove()
    }
    this.getCopyAndPayId();
    // this.dialogRef.close(id);
  }

  openSnackBar(message) {
    this.snackBar.open(message, '✖', {
      duration: 1000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    });
  }

  iOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

}
